import { render } from "./sanjiaoxinghexing.vue?vue&type=template&id=2157ef79&scoped=true"
import script from "./sanjiaoxinghexing.vue?vue&type=script&lang=js"
export * from "./sanjiaoxinghexing.vue?vue&type=script&lang=js"

import "./sanjiaoxinghexing.vue?vue&type=style&index=0&id=2157ef79&scoped=true&lang=css"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2157ef79"]])

export default __exports__